import type { StripeEventSort } from "../../../service/stripe-event-sort.models";
import { z } from "zod";

import type { TransactionContext } from "../../transaction-context";
import type { BillingJsonValue } from "./metadata";

export const stripeEventStatusSchema = z.enum([
  "received",
  "processing",
  "processed",
  "failed",
  "ignored",
]);

export type StripeEventStatus = z.infer<typeof stripeEventStatusSchema>;

export interface StripeEvent {
  id: string;
  stripeEventId: string;
  eventType: string;
  livemode: boolean;
  status: StripeEventStatus;
  payload: BillingJsonValue;
  summary?: BillingJsonValue;
  errorMessage?: string;
  attemptCount: number;
  processedAt?: Date;
  createdAt: Date;
  updatedAt: Date;
}

export interface RecordStripeEventInput {
  stripeEventId: string;
  eventType: string;
  livemode: boolean;
  payload: BillingJsonValue;
  summary?: BillingJsonValue;
  receivedAt?: Date;
}

export interface StripeEventInsertResult {
  event: StripeEvent;
  inserted: boolean;
}

export interface UpdateStripeEventStatusInput {
  stripeEventId: string;
  status: StripeEventStatus;
  summary?: BillingJsonValue;
  errorMessage?: string;
  processedAt?: Date;
  incrementAttemptCount?: boolean;
}

export interface ListStripeEventsInput {
  limit?: number;
  search?: string;
  status?: StripeEventStatus;
  /**
   * Ordering applied in SQL. The list is capped rather than paginated, so this
   * decides which events come back, not just their arrangement.
   */
  sort?: StripeEventSort | null;
  ctx?: TransactionContext;
}
